/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class WindowRestoreDefaultAction
 *
 * @brief restore workspace layout to factory default
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class WindowRestoreDefaultAction extends Action {

  constructor(options: any = null) {

    super({
      key:   'window.layout.restore',
      type:  ActionType.Window_Restore_Default,
      label: 'Restore Layout',
      icon:  '<i class="fas fa-window-restore"></i>',
      tip:   'Restore workspace layout to factory default'
    });

  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowRestoreDefaultAction] executing...');






    return true;
  }
}
